import { TravelReservation_Trip } from '@com-delta-idp/mnx-trip-management-shared-ui';
import {
  SEGMENTS,
  TRAVEL_RESERVATION_SEGMENTS
} from './travel-reservation-segments.mocks';

export const TRAVEL_RESERVATION_TRIPS: TravelReservation_Trip[] = [
  {
    tripId: 1,
    ordinal: 1,
    transportOrigin: {
      scheduledDepartureLocalDateTime: '2022-12-23T07:00:00-05:00',
      estimatedDepartureLocalDateTime: '2022-12-23T07:00:00-05:00',
      departureStatus: 'ON_TIME',
      station: {
        code: 'JAX',
        name: 'Jacksonville Intl',
        postalAddress: {
          cityName: 'Jacksonville',
          countrySubdivision: {
            code: 'FL'
          }
        }
      }
    },
    transportDestination: {
      scheduledArrivalLocalDateTime: '2022-12-24T14:50:00-10:00',
      estimatedArrivalLocalDateTime: '2022-12-24T14:50:00-10:00',
      arrivalStatus: 'ON_TIME',
      station: {
        code: 'HNL',
        name: 'Honolulu Intl',
        postalAddress: {
          cityName: 'Honolulu',
          countrySubdivision: {
            code: 'HI'
          }
        }
      }
    },
    segments: TRAVEL_RESERVATION_SEGMENTS,
    international: false,
    checkinEligible: true,
    standbyEligible: true
  },
  {
    tripId: 2,
    ordinal: 2,
    transportOrigin: {
      scheduledDepartureLocalDateTime: '2022-12-25T18:25:00-10:00',
      estimatedDepartureLocalDateTime: '2022-12-25T18:25:00-10:00',
      departureStatus: 'ON_TIME',
      station: {
        code: 'HNL',
        name: 'Honolulu Intl',
        postalAddress: {
          cityName: 'Honolulu',
          countrySubdivision: {
            code: 'HI'
          }
        }
      }
    },
    transportDestination: {
      scheduledArrivalLocalDateTime: '2022-12-26T02:50:00-10:00',
      estimatedArrivalLocalDateTime: '2022-12-26T02:50:00-10:00',
      arrivalStatus: 'ON_TIME',
      station: {
        code: 'JAX',
        name: 'Jacksonville Intl',
        postalAddress: {
          cityName: 'Jacksonville',
          countrySubdivision: {
            code: 'FL'
          }
        }
      }
    },
    segments: SEGMENTS,
    international: false,
    checkinEligible: false,
    standbyEligible: false
  }
];

export const TRAVEL_RESERVATION_TRIPS_WITH_PROTECT: TravelReservation_Trip[] = [
  TRAVEL_RESERVATION_TRIPS[0],
  {
    ...TRAVEL_RESERVATION_TRIPS[1],
    iropProtect: {
      protect: true,
      iropTripId: '3',
      tripId: 2
    }
  }
];
